
export default {
  print: {
    print: 'Nyomtatás',
    segment: 'Szakasz',
    preparingPrinting: 'A nyomtatás előkészítése',
    readyToPrint: 'Nyomtatásra kész'
  }
}
